import { render, staticRenderFns } from "./StoreSettings.vue?vue&type=template&id=c1c9ddac"
import script from "./StoreSettings.vue?vue&type=script&lang=js"
export * from "./StoreSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports